import { useMutation } from '@tanstack/react-query';

type JobPostImportRequestPostRequest = {
  file: File;
};

export default function usePostJobPostImportRequest() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ file }: JobPostImportRequestPostRequest) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch('/agent/api/job_post_import_requests', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({ errors: ['アップロードに失敗しました'] }));
        throw new Error(errorData.errors?.[0] || 'アップロードに失敗しました');
      }

      return await response.json();
    },
  });
}
